var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "detail-event" },
    [
      _vm.event &&
      _vm.event.network == "facebook" &&
      (_vm.event.type == "message" || _vm.event.type == "message-reaction")
        ? _c("componentDiscussionFacebook", {
            attrs: {
              messages:
                _vm.discussion.body && _vm.discussion.body.discussion
                  ? _vm.discussion.body.discussion
                  : {},
              infoConversation:
                _vm.discussion.body && _vm.discussion.body.conversation
                  ? _vm.discussion.body.conversation
                  : {},
              infoUser:
                _vm.discussionuser &&
                _vm.discussionuser.body &&
                _vm.discussionuser.body.user
                  ? _vm.discussionuser.body.user
                  : {},
              event: _vm.event,
              page: _vm.page,
            },
            on: { changeStatus: _vm.changeStatus },
          })
        : _vm.event &&
          _vm.event.network == "instagram" &&
          (_vm.event.type == "message" || _vm.event.type == "message-reaction")
        ? _c("componentDiscussionInstagram", {
            attrs: {
              messages:
                _vm.discussion &&
                _vm.discussion.body &&
                _vm.discussion.body.discussion
                  ? _vm.discussion.body.discussion
                  : {},
              infoConversation:
                _vm.discussion &&
                _vm.discussion.body &&
                _vm.discussion.body.conversation
                  ? _vm.discussion.body.conversation
                  : {},
              infoUser:
                _vm.discussionuser &&
                _vm.discussionuser.body &&
                _vm.discussionuser.body.user
                  ? _vm.discussionuser.body.user
                  : {},
              event: _vm.event,
              page: _vm.page,
            },
            on: { changeStatus: _vm.changeStatus },
          })
        : _vm.event &&
          _vm.event.network == "linkedin" &&
          _vm.event.type == "message"
        ? _c("componentDiscussionLinkedin", {
            attrs: {
              messages:
                _vm.discussion &&
                _vm.discussion.body &&
                _vm.discussion.body.conversation
                  ? _vm.discussion.body.conversation
                  : {},
              infoConversation: _vm.event.data,
              infoUser: _vm.event.user,
              event: _vm.event,
              page: _vm.page,
            },
            on: { changeStatus: _vm.changeStatus },
          })
        : _vm.event &&
          _vm.event.type == "rating" &&
          _vm.event.network == "facebook"
        ? _c("componentFacebookRating", {
            attrs: { page: _vm.page, event: _vm.event },
            on: { changeStatus: _vm.changeStatus },
          })
        : _vm.event && _vm.event.network == "facebook"
        ? _c("componentPostFacebook", {
            attrs: { page: _vm.page, post: _vm.post, event: _vm.event },
            on: {
              changeStatus: _vm.changeStatus,
              updateEventMissingInfos: _vm.updateEventMissingInfos,
            },
          })
        : _vm.event && _vm.event.network == "instagram"
        ? _c("componentPostInstagram", {
            attrs: { page: _vm.page, post: _vm.post, event: _vm.event },
            on: { changeStatus: _vm.changeStatus },
          })
        : _vm.event && _vm.event.network == "linkedin"
        ? _c("componentPostLinkedin", {
            attrs: { page: _vm.page, post: _vm.post, event: _vm.event },
            on: {
              changeStatus: _vm.changeStatus,
              updateEventMissingInfos: _vm.updateEventMissingInfos,
            },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }